<t4-container title="{{ 'T4.Settings.IframeGenerator.pnlIframe' | translate : 'Settings' }}">
  <mat-tab-group>
    <mat-tab label="Iframe">
      <div>
        <h4>Settings</h4>
        <button mat-raised-button (click)="copyToClipboard(iframeText)" style="position: absolute; right: 0; top: 0; margin: 10px;">Copy<mat-icon>content_paste</mat-icon></button>
        <span style="margin:20px">
          <pre>{{iframeText}}</pre>
        </span>
        <h4>Instructions and Notes</h4>
        <div style="padding:10px 0 0 25px;">
          <h5>Copy and Paste</h5>
          <p>
            Copy both the iframe code and JavaScript code provided by us, and then paste them directly into the HTML code on your website where you want the embedded content to appear.
          </p>
          <p>
            *If your CMS supports it, you can paste the code directly. Otherwise, you may need to add it element by element to ensure it matches your site's structure.
          </p>
          <h5>Save and Test</h5>
          <p>
            After pasting the code, save your changes. The iframe should now be embedded on your website. Be sure to test it to confirm that it adjusts its height accordingly to the content displayed.
          </p>
          <p>
            No modifications are necessary to the provided code; simply copy and paste it, and then save it to ensure proper functionality.
          </p>
        </div>
      </div>
    </mat-tab>
    @if (Settings.isInAny(['BackOffice', 'Admin'], true)) {
    <mat-tab label="Webbooking Script ">
      <div>
        <h4>Script</h4>
        <div style="position: absolute; right: 0; top: 0; margin: 10px;">
          <button mat-raised-button (click)="copyToClipboard(partnerScriptText)">Copy<mat-icon>content_paste</mat-icon></button>
          <button mat-raised-button (click)="popupKeysInfo()">Keys<mat-icon>privacy_tip</mat-icon></button>
        </div>
        <span style="margin:20px">
          <pre>{{webbookingScriptText}}</pre>
        </span>

        <h4>Settings</h4>
        <div style="display: flex; flex-direction: column; gap: 10px;">
          <mat-form-field style="width:auto">
            <mat-label>Theme</mat-label>
            <mat-select [(value)]="selectedTheme">
              @for (theme of themes; track $index) {
              <mat-option [value]="theme">{{theme}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width:auto">
            <mat-label>Languages</mat-label>
            <mat-select [(value)]="selectedlanguage">
              @for (lang of languages; track $index) {
              <mat-option [value]="lang">{{lang}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
      </div>
     </mat-tab>

    <mat-tab label="Partner Website Script ">
      <div>
        <h4>Script</h4>
        <div style="position: absolute; right: 0; top: 0; margin: 10px;">
          <button mat-raised-button (click)="copyToClipboard(partnerScriptText)">Copy<mat-icon>content_paste</mat-icon></button>
          <button mat-raised-button (click)="popupKeysInfo()">Keys<mat-icon>privacy_tip</mat-icon></button>
        </div>
        
        <span style="margin:20px">
          <pre>{{partnerScriptText}}</pre>
        </span>

        <h4>Settings</h4>
        <div style="display: flex; flex-direction: column; gap: 10px;">
          <mat-form-field style="width:fit-content">
            <mat-label>Theme</mat-label>
            <mat-select [(value)]="selectedTheme" (valueChange)="updatePartnerScript()">
              @for (theme of themes; track $index) {
              <mat-option [value]="theme">{{theme}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field style="width: fit-content">
            <mat-label>Languages</mat-label>
            <mat-select [(value)]="selectedlanguage" (valueChange)="updatePartnerScript()">
              @for (lang of languages; track $index) {
              <mat-option [value]="lang">{{lang}}</mat-option>
              }
            </mat-select>
          </mat-form-field>

        </div>
      </div>
    </mat-tab>
      }

  </mat-tab-group>
</t4-container>

